import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';

import { findPost } from '../posts';
import PostMarkdown from '../components/PostMarkdown';

const formatDate = (iso: string): string => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch {
        return iso;
    }
};

const BlogPost: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const post = slug ? findPost(slug) : undefined;

    React.useEffect(() => {
        if (post?.href) window.location.replace(post.href);
    }, [post]);

    if (!post) {
        return <Navigate to="/journal" replace />;
    }
    if (post.href) {
        return null;
    }

    return (
        <main className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-12 py-16 sm:py-24">
            <nav className="mb-16">
                <Link
                    to="/journal"
                    className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-500 dark:text-ink-400 no-underline hover:text-accent dark:hover:text-accent-soft transition-colors"
                >
                    ← Back to journal
                </Link>
            </nav>

            <header className="mb-12">
                <h1 className="font-display font-light text-[36px] sm:text-[52px] text-ink-900 dark:text-ink-50 tracking-tight leading-[1.1]">
                    {post.title}
                </h1>
                <time
                    className="block mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-ink-500 dark:text-ink-400"
                    dateTime={post.date}
                >
                    {formatDate(post.date)}
                </time>
            </header>

            <article>
                <PostMarkdown markdown={post.body} />
            </article>

            <footer className="mt-20 pt-8 border-t border-ink-200 dark:border-ink-700">
                <Link
                    to="/journal"
                    className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-500 dark:text-ink-400 no-underline hover:text-accent dark:hover:text-accent-soft transition-colors"
                >
                    ← Back to journal
                </Link>
            </footer>
        </main>
    );
};

export default BlogPost;
